import {
  ActionName,
  CategoryName,
  DisplayModeName,
  IInParamsValues,
} from '@infotech-soe/metaschema';
import omit from 'lodash/omit';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { CategoryOpenMode } from '../../../models/category/category';
import { IPanelLink } from '../../../models/dataset/DatasetRelated';
import UniqueId from '../../../services/uid/UniqueId';
import { AppDispatch } from '../../../store';
import { AppState } from '../../../store/reducers/root';
import { hasDisplayModeContentTab } from '../../../store/selectors/content';
import {
  getCurrentOpenedId,
  getFilteredMenuItems,
  getMenuFilter,
  getMenuItem,
  getRootMenuIds,
  isMenuOpened,
} from '../../../store/selectors/menu';
import { getSystemNotificationsSortedByStartTs } from '../../../store/selectors/systemNotifications';
import { getPanelLinksConfig } from '../../../store/selectors/userConfig';
import category from '../../../store/slices/category';
import content from '../../../store/slices/content';
import menu from '../../../store/slices/menu';
import userConfig from '../../../store/slices/userConfig';
import ApplicationMenu from '../../components/menu/ApplicationMenu';

const mapStateToProps = (state: AppState) => {
  const filteredItems = getFilteredMenuItems(state);
  const systemNotifications = getSystemNotificationsSortedByStartTs(state);

  return {
    collapsed: !isMenuOpened(state),
    currentOpenedMenuId: getCurrentOpenedId(state),
    items: filteredItems.length > 0 ? filteredItems : getRootMenuIds(state),
    query: getMenuFilter(state),
    rootMenuIds: getRootMenuIds(state),
    sysNotificationsNumber: systemNotifications.length,
    getItem: (id: UniqueId) => getMenuItem(state, id),
    isAlreadyOpen: (
      categoryName: CategoryName,
      displayModeName: DisplayModeName
    ) => hasDisplayModeContentTab(state, categoryName, displayModeName),

    links: getPanelLinksConfig(state),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onActivateOpen: (
    categoryName: CategoryName,
    displayModeName: DisplayModeName
  ) =>
    dispatch(
      content.activateDisplayMode({
        category: categoryName,
        displayMode: displayModeName,
      })
    ),
  onClickOnGroupItem: (id: UniqueId) => dispatch(menu.setCurrentOpenedId(id)),
  onFilterMenu: (query: string) => dispatch(menu.filter({ filter: query })),
  onOpenNew: (
    categoryName: CategoryName,
    displayMode: DisplayModeName,
    inParams: IInParamsValues | undefined,
    withDefaultConfig: boolean,
    nextAction?: ActionName
  ) =>
    dispatch(
      category.openDisplayMode({
        category: categoryName,
        displayMode,
        ui: {
          mode: nextAction ? CategoryOpenMode.HIDDEN : CategoryOpenMode.CONTENT,
        },
        inParams,
        withDefaultConfig,
        nextAction,
      })
    ),
  onSavePanelLinks: (links: IPanelLink[]) =>
    dispatch(userConfig.savePanelLinks(links)),
  onSubmitSearchQuery: () => dispatch(menu.submitSearch()),
  onToggleMenu: (open?: boolean) => dispatch(menu.toggleOpened(open)),
});

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  dP: ReturnType<typeof mapDispatchToProps>
) => ({
  ...omit(sP, ['links']),
  ...dP,
  onSavePanelLink: (newLink: IPanelLink) => {
    const isDuplicate = sP.links.some(
      link =>
        link.category === newLink.category &&
        link.displayMode === newLink.displayMode &&
        link.action === newLink.action
    );
    if (!isDuplicate) dP.onSavePanelLinks([...sP.links, newLink]);
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type ApplicationMenuContainerProps = ConnectedProps<typeof connector>;

export default connector(ApplicationMenu);
